var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchIconBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56055 5.16992V9.72992C6.56317 10.233 6.7642 10.7148 7.11995 11.0705C7.4757 11.4263 7.95745 11.6273 8.46055 11.6299H10.2305",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68 13.7099H10.23V13.8999C10.23 14.4038 10.0298 14.8871 9.6735 15.2434C9.31718 15.5997 8.83391 15.7999 8.33 15.7999H2.9C2.39609 15.7999 1.91282 15.5997 1.5565 15.2434C1.20018 14.8871 1 14.4038 1 13.8999V7.06992C1 6.56601 1.20018 6.08274 1.5565 5.72642C1.91282 5.3701 2.39609 5.16992 2.9 5.16992H3.78V11.8099C3.78 12.3138 3.98018 12.7971 4.3365 13.1534C4.69282 13.5097 5.17609 13.7099 5.68 13.7099Z",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2293 11.6298H8.4593C7.9562 11.6272 7.47445 11.4262 7.1187 11.0704C6.76295 10.7147 6.56192 10.2329 6.5593 9.72984V3.08984H5.6793C5.17539 3.08984 4.69211 3.29002 4.33579 3.64634C3.97947 4.00266 3.7793 4.48593 3.7793 4.98984V11.8098C3.7793 12.3138 3.97947 12.797 4.33579 13.1533C4.69211 13.5097 5.17539 13.7098 5.6793 13.7098H10.2293",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56055 3.08984V9.72984C6.56317 10.2329 6.7642 10.7147 7.11995 11.0704C7.4757 11.4262 7.95745 11.6272 8.46055 11.6298H10.2305",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205 11.6299V11.8099C13.0205 12.3138 12.8203 12.7971 12.464 13.1534C12.1077 13.5097 11.6244 13.7099 11.1205 13.7099H10.2305",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8005 2.9V9.73C15.8005 10.2339 15.6004 10.7172 15.2441 11.0735C14.8877 11.4298 14.4045 11.63 13.9005 11.63H8.46055C7.95745 11.6274 7.4757 11.4264 7.11995 11.0706C6.7642 10.7148 6.56317 10.2331 6.56055 9.73V2.9C6.56317 2.3969 6.7642 1.91515 7.11995 1.5594C7.4757 1.20365 7.95745 1.00263 8.46055 1H13.9005C14.4045 1 14.8877 1.20018 15.2441 1.5565C15.6004 1.91282 15.8005 2.39609 15.8005 2.9Z",
    stroke: "#23272E",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8694 8.75047H8.86938M13.6294 6.40047H8.88937M13.6094 3.98047L8.85938 4.03047",
    stroke: "#23272E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchIconBold);
export default __webpack_public_path__ + "static/media/BatchIconBold.14e04ec8f6faa49042b43fec3e7b6cfd.svg";
export { ForwardRef as ReactComponent };